module.exports = __webpack_public_path__ + "img/AMTE.a07b2063.jpg";